module.exports = __webpack_public_path__ + "static/android-chrome-512x512-7a9697e7060cce09e2562e96a9859b6e.png";